import { render, staticRenderFns } from "./leads-details.vue?vue&type=template&id=2fcb2fe7"
import script from "./leads-details.vue?vue&type=script&lang=js"
export * from "./leads-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports